import * as constants from '../constants';

const mutations = {
  [constants.USER_AUTH_LOGIN]: (state, token) => {
    state.token = token;
  },
  [constants.USER_AUTH_LOGOUT]: (state) => {
    state.token = '';
  },
  [constants.USER_CUSTOMER]: (state, customer) => {
    state.customer = customer;
  },
  [constants.USER_ORDERS]: (state, orders) => {
    state.orders = orders;
  },
  [constants.INCADEA_ORDERS]: (state, orders) => {
    state.incadeaOrders = orders;
  },
  [constants.USER_ORDER]: (state, order) => {
    state.order = order;
  },
  [constants.USER_SHOPPING_LIST]: (state, shoppingList) => {
    state.shoppingList = shoppingList;
  },
};

export default mutations;
